import React from 'react';
import styled from 'styled-components';
import parse, { HTMLReactParserOptions, Element, domToReact, DOMNode } from 'html-react-parser';
import { Link as StyledLink } from '@makeship/core';
import { P2, H1, H2, H3, H4, H5, H6 } from '../components/Typography';

const IFrame = styled.iframe`
  width: 100%;
`;

type TransformType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: React.ComponentType<any>;
};

export const defaultTransform: TransformType = {
  p: P2,
  a: StyledLink.Primary,
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  iframe: IFrame,
};

const parseStyleString = (styleStr: string): Record<string, string> => {
  const styles: Record<string, string> = {};

  if (!styleStr) return styles;

  styleStr.split(';').forEach((rule) => {
    const [property, value] = rule.split(':').map((s) => s.trim());
    if (property && value) {
      const camelCaseProperty = property.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
      styles[camelCaseProperty] = value;
    }
  });

  return styles;
};

export const transformHtml = (html: string, transform: TransformType = defaultTransform): React.ReactNode => {
  const options: HTMLReactParserOptions = {
    replace(domNode) {
      if (domNode instanceof Element && domNode.name && domNode.attribs) {
        const { name, attribs, children } = domNode;

        if (transform[name]) {
          const ComponentToRender = transform[name];

          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const processedAttribs: any = { ...attribs };

          if (processedAttribs.style && typeof processedAttribs.style === 'string') {
            processedAttribs.style = parseStyleString(processedAttribs.style);
          }

          return React.createElement(ComponentToRender, processedAttribs, domToReact(children as DOMNode[], options));
        }
      }
    },
  };

  return parse(html, options);
};
